/* Column sizes on the server (api/app/models/member.py). Checked here first so a
   member sees "shorten this" under the field while typing, instead of a save
   that silently fails. */
export const LIMITS = {
  name: 120,
  headline: 240,
  location: 120,
  timezone_label: 40,
  languages: 120,
  org_name: 160,
  org_url: 320,
};

export function overLimit(key, value) {
  const max = LIMITS[key];
  return Boolean(max && typeof value === 'string' && value.length > max);
}
